import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui components
import withStyles from "material-ui/styles/withStyles";
// @material-ui/icons
// core components
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import SectionContent from "./Sections/SectionContent";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";

class ServicesPage extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Parallax image={require("assets/img/bg6.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title}>Services</h1>
                  <h3 className={classes.subtitle}>
                    React.js | Redux | Solidity Ethereum Apps
                  </h3>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}> 
            <SectionContent />
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(ServicesPage);



// WEBPACK FOOTER //
// ./src/views/ServicesPage/ServicesPage.jsx